export default "/images/ico-plus-circ.svg?5c0cb9fc4faa79c565c74c5d7b772761";